import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheckIcon, ChartBarIcon, ClockIcon } from '@heroicons/react/24/outline';
import About from './About';
import Services from './Services';
import Contact from './Contact';

const images = [
  { src: require('../../assets/image3.jpeg'), alt: 'Pharmacy Display 3' },
  { src: require('../../assets/image2.jpeg'), alt: 'Pharmacy Display 2' },
  { src: require('../../assets/image1.jpeg'), alt: 'Pharmacy Display 1' },
  { src: require('../../assets/image4.jpeg'), alt: 'Pharmacy Display 4' },
];

const Home = () => {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative w-full">
      {/* Full Screen Image Hero */}
      <div className="relative w-full h-[calc(100vh-80px)] overflow-hidden">
        {images.map((img, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
              index === currentImage ? 'opacity-100 z-10' : 'opacity-0 z-0'
            }`}
          >
            <div className="absolute inset-0 bg-slate-900/60 z-10"></div>
            <img
              src={img.src}
              alt={img.alt}
              className="w-full h-full object-cover transform scale-105"
            />
          </div>
        ))}
        
        {/* Hero Content Overlay */}
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 text-center">
          {/* Hero text and buttons removed as requested */}
          
          {/* Slider Indicators */}
          <div className="absolute bottom-10 left-0 right-0 flex justify-center gap-3">
            {images.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentImage(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentImage ? 'bg-emerald-400 w-8' : 'bg-white/50 hover:bg-white/80'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              ></button>
            ))}
          </div>
        </div>
      </div>

      {/* Feature Highlights removed as requested */}

      {/* About Section */}
      <About />

      {/* Services Section */}
      <Services />

      {/* Contact Section */}
      <Contact />
    </div>
  );
};

export default Home;
